export default "__VITE_ASSET__DZE4AGLA__"